import React from 'react';
import styled from 'styled-components';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { ConfigFieldControl } from '@sierralabs/core-ui';
import { useFindNearestRouteComponent } from '../../hooks/site-route/useFindNearestRouteComponent';
import { useSiteRouteComponents } from '../../hooks/site-route/useSiteRouteComponents';
import { getRouteParams } from '../../plugins/events/SiteEventRoutePlugin';
import SiteRoutePicker from './SiteRoutePicker';
const StyledConfigFieldControl = styled(ConfigFieldControl) `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
export function updateRouteAndParam(value, idPath, paramPath) {
    const result = [];
    if (value.hasOwnProperty('routeId')) {
        result.push([idPath, value.routeId]);
    }
    if (value.hasOwnProperty('routeParam')) {
        result.push([paramPath, value.routeParam]);
    }
    return result;
}
// SiteRoutePicker with autocomplete picker for route param
export const SiteRouteAndParamPicker = props => {
    var _a;
    let { routeId } = props;
    const { component, routeParam, nearest = false, nearestOnly = false, siteRoutePickerProps, textFieldProps, onChange } = props;
    const routes = useSiteRouteComponents();
    const nearestRoute = useFindNearestRouteComponent(component);
    routeId =
        (nearest || nearestOnly) && nearestRoute ? nearestRoute.id : routeId;
    const selectedRoute = routeId
        ? routes.find(route => route.id === routeId)
        : undefined;
    const params = getRouteParams(((_a = selectedRoute === null || selectedRoute === void 0 ? void 0 : selectedRoute.props) === null || _a === void 0 ? void 0 : _a.path) || '');
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledConfigFieldControl, null,
            React.createElement(SiteRoutePicker, Object.assign({}, siteRoutePickerProps, { value: routeId, disabled: nearestOnly || (siteRoutePickerProps === null || siteRoutePickerProps === void 0 ? void 0 : siteRoutePickerProps.disabled), onChange: route => {
                    onChange === null || onChange === void 0 ? void 0 : onChange({ routeId: route === null || route === void 0 ? void 0 : route.id, routeParam: undefined });
                } }))),
        React.createElement(StyledConfigFieldControl, null,
            React.createElement(Autocomplete, { fullWidth: true, options: params, disabled: !routeId, value: routeParam || null, onChange: (_, value) => {
                    // in the case where routeId is the nearestRoute.id,
                    // also update routeId if it's different from props.routeId
                    const update = {
                        routeParam: value || undefined
                    };
                    if (props.routeId !== routeId) {
                        update.routeId = routeId;
                    }
                    onChange === null || onChange === void 0 ? void 0 : onChange(update);
                }, renderInput: params => {
                    const inputProps = Object.assign(Object.assign(Object.assign({}, params.InputProps), { disableUnderline: true }), textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.InputProps);
                    if (!inputProps.disableUnderline) {
                        delete inputProps.disableUnderline;
                    }
                    return (React.createElement(TextField, Object.assign({}, params, { fullWidth: true, size: 'small', label: 'Route Param', placeholder: 'Select Route Param' }, textFieldProps, { InputProps: inputProps })));
                } }))));
};
export default SiteRouteAndParamPicker;
//# sourceMappingURL=SiteRouteAndParamPicker.js.map